import SiteNav from "./components/SiteNav";
import HeroSection from "./components/HeroSection";
import TickerBar from "./components/TickerBar";
import NewsBriefList from "./components/NewsBriefList";
import HotRankingList from "./components/HotRankingList";
import ConfirmedStories from "./components/ConfirmedStories";
import ExposeBoard from "./components/ExposeBoard";
import DiscussionBoard from "./components/DiscussionBoard";
import TrustSection from "./components/TrustSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div id="top" className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <SiteNav />
      <main>
        <HeroSection />
        <TickerBar />

        <section className="w-full px-4 py-10 md:px-8 md:py-14">
          <div className="grid gap-8 lg:grid-cols-12 lg:gap-10">
            <div className="lg:col-span-8">
              <NewsBriefList />
            </div>
            <div className="lg:col-span-4">
              <HotRankingList />
            </div>
          </div>
        </section>

        <ConfirmedStories />
        <ExposeBoard />
        <DiscussionBoard />
        <TrustSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
    </div>
  );
}